import React, { Suspense, useEffect } from 'react';
import InitApm from './core/apm';
import Router from './core/routes';
import { RouterProvider } from 'react-router-dom';
import './index.css';
import 'swiper/swiper-bundle.css';
import { Toast } from './core/components/atoms/Toast';
import { setAuthToken } from './core/commom/authToken';
import { useUserStore } from './modules/Auth/stores/authStore';
import { setTheme } from './core/utils';
import GTM from './core/track/gtm';
import { loadScriptCubos } from './core/track/cubos';
import { loadWootric } from './core/track/wootric';
import { AuthRoutes } from './modules/Auth/routes';
import iaAssistant from './core/track/iaAssistant';
import GlobalFreemiumUpsell from './core/components/organism/FreemiumLockModal/GlobalFreemiumUpsell';
import GlobalMostraSeuAprova from './core/components/organism/MostraSeuAprovaModal/GlobalMostraSeuAprova';

export default function App() {
  const { user } = useUserStore();

  function updateUserTheme() {
    if (window.location.pathname.includes('/simuladao')) {
      setTheme('light');
      return;
    }

    setTheme(user && user.isDarkMode ? 'dark' : 'light');
  }

  useEffect(() => {
    InitApm();
    GTM();

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (params.has('token')) {
      const token = params.get('token');
      if (token) {
        setAuthToken(token);
      }
    }
  }, []);

  useEffect(() => {
    if (user && user.email) {
      loadWootric(user);
    }
  }, [user]);

  useEffect(() => {
    if (user && window) {
      iaAssistant(user);
    }
    return () => {
      console.log('unmount');
    };
  }, [user, window]);

  useEffect(() => {
    updateUserTheme();
  }, [user?.isDarkMode]);

  useEffect(() => {
    const authPaths = AuthRoutes.map((route) => route.path.split('/')[0]);

    const isInAuth = authPaths.some((path) =>
      window.location.pathname.includes(path)
    );

    if (!isInAuth) {
      localStorage.setItem('lastPath', window.location.pathname);
    }

    updateUserTheme();
  }, [window.location.pathname]);

  return (
    <Suspense fallback={<></>}>
      <Toast />
      <GlobalFreemiumUpsell />
      <GlobalMostraSeuAprova />
      <RouterProvider router={Router} fallbackElement={<p>Carregando</p>} />
    </Suspense>
  );
}
